import { PAYMENT_METHODS_ENUM } from "types/PaymentMethodsTypes";

export default {
  auth: {
    login: "login",
    register: "register",
  },
  casino: {
    root: "/",
    popular: "popular",
    new: "new",
    favorite: "favorite",
    slots: "slots",
    table: "table",
    lottery: "lottery",
    videopoker: "video-poker",
    roulette: "roulette",
    blackjack: "blackjack",
    scratch: "scratch",
    poker: "poker",
    bingo: "bingo",
    vsport: "v-sport",
    baccara: "baccara",
    arcade: "arcade",
    keno: "keno",
    instant: "instant",
    other: "other",
    providers: {
      root: "providers",
      provider: "providers/:provider",
    },
    live: "live-casino",
    jackpot: "jackpot",
    provider: "/:provider",
    category: "/:category",
    game: "/slots/:game",
    sportBook: "/sportsbook",
    sportsBook: "sportsbook/:event/:id",
  },
  profile: {
    root: "profile",
    transactionHistory: {
      root: "transactions",
      // type: "/:type",
      deposit: "transactions/deposit",
      withdrawal: "transactions/withdrawal",
    },
    gamesHistory: "games",
    achievements: "achievements",
    bonus: "bonus",
    loyaltyProgram: {
      root: "loyalty",
      rules: "loyalty/rules",
      ranks: "loyalty/ranks",
    },
    cashback: "cashback",
    inviteFriend: "invite",
    personal: "personal",
    safety: "safety",
    notification: {
      root: "notification",
    },
    personalInfo: "personal-info",
  },
  tournament: {
    root: "tournament",
    tournamentId: ":id",
  },
  landing: {
    root: "land",
    aviator: "aviator",
    cointStrike: "coin-strike",
    wheels: {
      root: "wheels",
      girls: "wheels/girls",
      girlsBangladesh: "wheels/girls-bangladesh",
      teenagers: "wheels/teenagers",
      cards: "wheels/cards",
      aviator: "wheels/aviator",
      chicksTurkey: "wheels/chicks-turkey",
      chicksBangladesh: "wheels/chicks-bangladesh",
      chicksUzbekistan: "wheels/chicks-uzbekistan",
      chicksAzer: "wheels/chicks-azerbaijan",
      crazyTime: "wheels/crazy-time",
      roulette: "wheels/roulette",
      sweetBonanza: "wheels/sweet-bonanza",
      gatesOlympus: "wheels/olympus",
    },
  },
  info: {
    root: "info",
    about: "about",
    conditions: "conditions",
    kycaml: "kycaml",
    privacy: "privacy",
    responsiblegame: "responsiblegame",
    cookies: "cookies",
    support: "support",
    welcomeBonus: "welcome-bonus",
    loyaltyProgram: "loyalty",
  },
  pages: {
    root: "pages",
    serviceError: "service_error",
    notAvailablePage: "not_available",
    banned: "banned",
  },
  promo: {
    root: "promo",
  },
  newGlory: {
    root: "new",
  },
  api: {
    auth: {
      login: "/auth/login",
      register: "/auth/register",
      recovery: "/auth/password/email",
      passwordReset: "/auth/email_password_reset",
      password: "/auth/password/change",
      changeEmail: "/auth/email/change",
    },
    catalogs: {
      currencies: "/users/currencies",
      languages: "/users/languages",
      localization: "/localization",
      phoneCountries: "/users/countries",
    },
    games: {
      games: "/games",
      categories: "/games/categories",
      lobbies: "/games/lobbies",
      init: (id: string) => `/games/${id}/init`,
      initByAlias: (alias: string) => `/games/init-by-alias/${alias}`,
      initDemoByAlias: (alias: string) => `/games/init-demo-by-alias/${alias}`,
      initDemo: (id: string) => `/games/${id}/init_demo`,
      providers: "/games/providers",
      favorites: "/games/favorites",
      history: "/games/history",
      toggleFavorite: (id: string) => `/games/${id}/favorite`,
      freeSpinGames: "/games/freespin-games",
      gamesIds: "/games/ids",
      sportsBook: "/games/sportbook/auth/get-jwt-token",
    },
    geo: {
      geosList: "/geo",
      geoByIp: "/geo/ip",
      geoByCountry: (name: string) => `/geo/${name}`,
    },
    payments: {
      methods: "/payments/payment_methods",
      banks: "/payments/payment_methods/banks",
      transactions: "/transactions",
      anindaHavaleDeposit: "/payments/instapays/aninda_havale/deposit",
      anindaHavaleWithdraw: "/payments/instapays/aninda_havale/withdrawal",
      bankCardsDeposit: "/payments/instapays/credit_cards/deposit",
      exPayWithdraw: "/payments/expay/withdrawal",
      expressHavaleDeposit: "/payments/instapays/express/deposit",
      expressHavaleWithdraw: "/payments/instapays/express/withdrawal",
      havaleHeraDeposit: "/payments/havale-payhera/bank_transfer/deposit",
      havaleHeraWithdraw: "/payments/havale-payhera/bank_transfer/withdrawal",
      havaleHeraBanks: "/payments/havale_hera/banks",
      paparaDeposit: "/payments/simple-pay/papara/deposit",
      paparaWithdraw: "/payments//simple-pay/papara/withdrawal",
      epulDeposit: "/payments/epul/deposit",
      epulWithdraw: "/payments/epul/withdrawal",
      paycosDeposit: "/payments/paycos/deposit",
      paycosWithdraw: "/payments/paycos/withdrawal",
      havaleVipDeposit: "/payments/instapays/havale_vip/deposit",
      havaleVipWithdraw: "/payments/instapays/havale_vip/withdrawal",
      mefeteDeposit: "/payments/instapays/mft/deposit",
      mefeteWithdraw: "/payments/instapays/mft/withdrawal",
      payfixDeposit: "/payments/payturka/payfix/deposit",
      payfixWithdraw: "/payments/payturka/payfix/withdrawal",
      azarpayBanks: "/payments/azarpay/banks",
      azarpayDeposit: "/payments/azarpay/dep",
      azarpayWithdraw: "/payments/azarpay/withdrawal",
      wangupayWithdraw: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/wangupay/${method.toLowerCase()}/withdrawal`,
      cashixDeposit: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/cashix/${method.toLowerCase()}/deposit`,
      cashixWithdraw: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/cashix/${method.toLowerCase()}/withdrawal`,
      corefyDeposit: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/corefy/${method.toLowerCase()}/deposit`,
      corefyWithdraw: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/corefy/${method.toLowerCase()}/withdrawal`,
      ccDeposit: "/payments/mpay/credit-card/deposit",
      troyDeposit: "/payments/troy/credit-card/deposit",
      upiVFast: "/payments/apay/upi_fast_v/deposit",
      valerpayDeposit: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/valerpay/${method.toLowerCase()}/deposit`,
      valerpayWithdraw: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/valerpay/${method.toLowerCase()}/withdrawal`,
      paykassmaDepositCreate: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/paykassma/${method.toLowerCase()}/deposit`,
      paykassmaDepositActivate: "/payments/paykassma/deposit/activate",
      paykassmaWithdraw: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/paykassma/${method.toLowerCase()}/withdrawal`,
      simplepayDeposit: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/simple-pay/${method.toLowerCase()}/deposit`,
      simplepayWithdraw: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/simple-pay/${method.toLowerCase()}/withdrawal`,
      wellxpayDeposit: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/wellxpay/${method.toLowerCase()}/deposit`,
      wellxpayWithdraw: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/wellxpay/${method.toLowerCase()}/withdrawal`,
      smartProPayDeposit: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/smart-pro-pay/${method.toLowerCase()}/deposit`,
      smartProPayWithdraw: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/smart-pro-pay/${method.toLowerCase()}/withdrawal`,
      maksiparaDeposit: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/maksipara/${method.toLowerCase()}/deposit`,
      maksiparaWithdraw: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/maksipara/${method.toLowerCase()}/withdrawal`,
      constantposDeposit: "/payments/constantpos/upi/deposit",
      constantposWithdraw: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/constantpos/${method.toLowerCase()}/withdrawal`,
      apayDeposit: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/apay/${method.toLowerCase()}/deposit`,
      wangupayDeposit: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/wangupay/${method.toLowerCase()}/deposit`,
      apayWithdraw: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/apay/${method.toLowerCase()}/withdrawal`,
      octopaysDeposit: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/octopays/deposit/${method.toLowerCase()}`,
      octopaysWithdraw: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/octopays/withdrawal/${method.toLowerCase()}`,
      vevopayDeposit: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/vevopay/${method.toLowerCase()}/deposit`,
      payokDeposit: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/payok/${method.toLowerCase()}/deposit`,
      payokWithdraw: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/payok/${method.toLowerCase()}/withdrawal`,
      bitoloDeposit: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/bitolo/${method.toLowerCase()}/deposit`,
      bitoloWithdraw: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/bitolo/${method.toLowerCase()}/withdrawal`,
      spayzDeposit: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/spayz/${method.toLowerCase()}/deposit`,
      spayzWithdraw: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/spayz/${method.toLowerCase()}/withdrawal`,
      easypaygameDeposit: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/easy-pay-game/${method.toLowerCase()}/deposit`,
      easypaygameWithdraw: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/easy-pay-game/${method.toLowerCase()}/withdrawal`,
      ummoneyDeposit: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/um-money/${method.toLowerCase()}/deposit`,
      ummoneyWithdraw: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/um-money/${method.toLowerCase()}/withdrawal`,
      bovaWithdraw: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/bova/${method.toLowerCase()}/withdrawal`,
      inwizoDeposit: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/inwizo/${method.toLowerCase()}/deposit`,
      inwizoWithdraw: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/inwizo/${method.toLowerCase()}/withdrawal`,
      bovaDeposit: (method: PAYMENT_METHODS_ENUM) =>
        `/payments/bova/${method.toLowerCase()}/deposit`,
      zenpayDeposit: "/payments/zanpay/cp_Upi/deposit",
      zenpayWithdraw: "/payments/zanpay/cp_imps/withdrawal",
      cryptoDeposit: "/payments/crypto/crypto-processing/deposit",
    },
    user: {
      bonus: "/users/bonuses",
      cancelBonus: (id: number) => `/bonuses/cancel/${id}`,
      freeSpins: "/users/freespin_campaigns",
      profile: "/users/profile",
      edit: "/users/profile/edit",
    },
    banners: {
      // root: '/banners',
      root: "/banners/carousel",
    },
    bonuses: {
      cancelBonus: (id: number | string) => `/bonuses/cancel/${id}`,
      cancelFreeSpin: (id: number | string) => `/bonuses/freespin/cancel/${id}`,
      promocode: "/promo-codes/use-code-by-user",
    },
    tournament: {
      root: "/tournament",
    },
    participants: {
      root: "/participants",
    },
    referral: {
      root: "/referrer",
      referralList: "/referrals",
      enabled: "/referrals/service-enabled",
      withdrawal: "/referrals/transfer-balance",
    },
    rewardNominalUsers: {
      userRewards: "/reward-users/user-rewards",
      cancelBonusNominal: (id: number | string) => `/rewards/cancel/${id}`,
    },
    triggerCampains: {
      availableTriggers: "/trigger-compains/available-triggers",
    },
    splitService: {
      me: "/split-user/me",
    },
    loyalty: {
      loyaltyUser: "/loyalties/user",
      userRank: "/loyalties/user-rank",
      loyaltyMascots: "/loyalties/mascots",
      userMascots: "/mascots/user",
      activateMascot: (mascotId: string) => `/mascots/${mascotId}/activate`,
      userBoosters: "/boosters/user",
      boosters: "/boosters",
      boosterInfo: (id: string | number) => `/boosters/${id}/info`,
      activateBooster: (boosterId: string) => `/boosters/${boosterId}/activate`,
      userRewards: "/loyalties/reward/users",
      userRewardAssign: "/loyalties/reward/assign",
      cashbackInfo: "reward-cashback/user-value-info",
      assignCashback: "/reward-cashback/assign",
      rollbackStatus: "/loyalties/user/rollback-status",
      expSetting: "/exp-settings/by-currencies",
      loyaltyCashbackValueInfo: "/loyalties/cashback-value-info",
    },
    rewards: {
      info: "/rewards/info",
    },
  },
};
